import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  background-color: #82182e;
  border-bottom: 3px solid #fff;
  border-top: 3px solid #fff;
  display: flex;
  font-family: 'Qatar2022', sans-serif;
  font-size: 44px;
  font-weight: 900;
  height: 58px;
`;
Container.displayName = 'Container';

export const FlagImage = styled.img`
  border: 2px solid #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: 52px;
`;
FlagImage.displayName = 'FlagImage';

export const PointsAway = styled.div`
  color: #ffffff;
  right: 45px;
  position: relative;
  top: 3px;
  width: 14px;
`;
PointsAway.displayName = 'PointsAway';

export const PointsHome = styled.div`
  color: #ffffff;
  left: 35px;
  position: relative;
  top: 3px;
  width: 12px;
`;
PointsHome.displayName = 'PointsHome';

export const TeamColor = styled.svg`
  margin: 0 8px;
`;
TeamColor.displayName = 'TeamColor';

export const TeamName = styled.div`
  color: #ffffff;
  position: relative;
  top: 3px;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  color: #ffffff;
  margin: 0 18px 0 32px;
  position: relative;
  top: 3px;
`;
Timer.displayName = 'Timer';
